module.exports = __webpack_public_path__ + "img/vulcan-logo.9dd4eaad.svg";